import {
  Chip,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import classes from "./MedicationTemplateTable.module.scss";
import {RightChevron} from "../../../../../assets/icons/RightChevron";
import {Delete} from "../../../../../assets/icons/Delete";
import {
  IMedicationTemplateData,
} from "../../../../../utils/interfaces";
import {useNavigate} from "react-router-dom";
import {getMedicationFromTemplateText} from "../../../../../utils/commonUtils";

export const MedicationTemplateTable = ({data, deleteTemplate}: IMedicationTemplateData) => {
  const navigate = useNavigate();

  return (
    <TableContainer className={classes.tableContainer}>
      <Table className={classes.table} stickyHeader>
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell align="left">Plan Name</TableCell>
            <TableCell align="left">Medications</TableCell>
            <TableCell align="left">Times</TableCell>
            <TableCell align="center">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={classes.tableBody}>
          {data &&
            data.map(
              ({
                id,
                name,
                items,
              }) => {
                return (
                  <TableRow className={classes.tableRow} key={id}>
                    <TableCell align="left">{name}</TableCell>
                    <TableCell align="left">
                      <Stack spacing={2}>
                        {items.map((medication, index) => (
                          <span key={medication.id}>
                            {getMedicationFromTemplateText(medication, index)}
                          </span>
                        ))}
                      </Stack>
                    </TableCell>
                    <TableCell align="left">
                      <Stack spacing={2}>
                        {items.map((medication, index) => (
                          <Stack direction="row" spacing={1} key={index}>
                            {medication.times.map((time, index) => {
                              const splittedTime = time.split(':');
                              const formattedTime = `${splittedTime[0]}:${splittedTime[1]}`;

                              return (
                                <Chip sx={{minWidth: 60}} color="primary" size="small" key={index} label={formattedTime} variant="filled" />
                              )
                            })}
                          </Stack>
                        ))}
                      </Stack>
                    </TableCell>
                    <TableCell align="center">
                      <IconButton className={classes.deleteAction} onClick={() => deleteTemplate(id)}>
                        <Delete />
                      </IconButton>
                      <IconButton
                        onClick={() => navigate(`/medication-templates/view/${id}`)}
                      >
                        <RightChevron />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              }
            )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
